import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake, Users, Sprout, Inbox } from "lucide-react";
import PageHeader from "@/components/site/PageHeader";
import { FadeIn } from "@/components/motion";

const WHY = [
  {
    icon: HeartHandshake,
    title: "Work that matters daily",
    text: "Every day ends the same way: someone got home safely, and a family breathed easier.",
  },
  {
    icon: Users,
    title: "A team that communicates",
    text: "We practice what we promise families — clarity, warmth, and no one left guessing.",
  },
  {
    icon: Sprout,
    title: "Room to grow",
    text: "As Homevia grows, so do the people building it. Your ideas shape how care is delivered.",
  },
];

export default function Careers() {
  return (
    <div data-testid="careers-page">
      <PageHeader
        eyebrow="Careers at Homevia"
        lines={["Do the calmest work", "in healthcare."]}
        intro="Homevia is built by people who believe the quiet moments of care — the call returned, the plan explained, the transition made gentle — are the ones that matter most."
        testid="careers-heading"
      />

      <section className="px-6 pb-24 lg:px-10">
        <div className="mx-auto max-w-7xl">
          <FadeIn>
            <h2 className="font-serif text-4xl tracking-tight text-ink lg:text-5xl">Why Homevia</h2>
          </FadeIn>
          <div className="mt-12 grid gap-6 md:grid-cols-3">
            {WHY.map((w, i) => (
              <FadeIn key={w.title} delay={i * 0.1}>
                <div className="h-full rounded-3xl border border-olive/10 bg-white p-8 transition-all duration-500 hover:scale-[1.02] hover:border-teal/50">
                  <w.icon className="h-7 w-7 text-sage-dark" />
                  <h3 className="mt-6 font-serif text-2xl text-ink">{w.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-olive/70">{w.text}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      <section className="px-6 pb-24 lg:px-10 lg:pb-32">
        <div className="mx-auto max-w-7xl">
          <FadeIn>
            <h2 className="font-serif text-4xl tracking-tight text-ink lg:text-5xl">Open roles</h2>
          </FadeIn>
          <FadeIn delay={0.1}>
            <div
              data-testid="careers-open-roles-empty"
              className="mt-12 flex flex-col items-center rounded-[2rem] border border-dashed border-olive/20 bg-sand/40 p-14 text-center"
            >
              <span className="grid h-16 w-16 place-items-center rounded-full bg-sage/20">
                <Inbox className="h-7 w-7 text-teal-deep" />
              </span>
              <h3 className="mt-6 font-serif text-2xl text-ink">Open roles will be posted here</h3>
              <p className="mt-3 max-w-md text-olive/70">
                We don't have published openings right now, but we're always glad to meet people who
                care about this work. Introduce yourself and we'll keep you in mind.
              </p>
              <Link
                to="/careers/apply"
                data-testid="careers-apply-btn"
                className="mt-8 inline-flex items-center gap-2 rounded-full bg-teal-deep px-7 py-3.5 text-sm font-bold text-cream transition-all duration-300 hover:bg-olive hover:shadow-xl"
              >
                Introduce Yourself <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </FadeIn>
        </div>
      </section>
    </div>
  );
}
